import { render } from "./Sce.vue?vue&type=template&id=70c0bb02"
import script from "./Sce.vue?vue&type=script&lang=js"
export * from "./Sce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__